import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentRequestRoutingModule } from './document-request-routing.module';
import { DocumentRequestComponent } from './document-request.component';
import { CoreModule } from '../../core/core.module';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/primeng';

@NgModule({
  imports: [
    CalendarModule,
    CommonModule,
    CheckboxModule,
    CoreModule,
    DocumentRequestRoutingModule,
    DropdownModule,
    FormsModule,
    NgbModule,
    TableModule,
    TranslateModule,
  ],
  declarations: [DocumentRequestComponent]
})
export class DocumentRequestModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request.module.ts